export default "__VITE_ASSET__DnfOuC8m__"